<template>
  <div v-if="data.purchaseProductCouponId" class="history contents">
    <div class="view">
      <dl class="claimDate">
        <dt>{{ $t('cancel.withdrawal') }}</dt>
        <dd>{{ data.withdrawDate }}</dd>
      </dl>
      <dl class="purchaseDate">
        <dt>{{ $t('cancel.purchase_completed') }}</dt>
        <dd>{{ data.purchaseDate }}</dd>
      </dl>
      <dl class="purchaseNum">
        <dt>{{ $t('cancel.order_number') }}</dt>
        <dd>{{ data.purchaseId }}</dd>
      </dl>
      <ul class="listTypeCart">
        <li class="productItem">
          <list-item :product="data"></list-item>
        </li>
      </ul>
    </div>
    <div class="payInfo">
      <h2 class="subTitle">{{ $t('cancel.refund_info') }}</h2>
      <div>
        <dl>
          <dt class="accessibilityHide">
            {{ $t('cancel.withdrawal_process_date') }}
          </dt>
          <dd>{{ data.withdrawDate }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('cancel.refund_amount') }}</dt>
          <dd>
            {{ (data.price ? data.price : 0).addComma()
            }}{{ data.currencyUnit }}
          </dd>
        </dl>
        <dl>
          <dt>{{ $t('cancel.refund_method') }}</dt>
          <dd>{{ data.refundPaymentTypeName }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('cancel.refund_way') }}</dt>
          <dd>{{ $t('cancel.payment_cancellation') }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('cancel.refund_status') }}</dt>
          <dd>
            <span class="productStateRed">{{ status }}</span>
          </dd>
          <!-- <dd><span class="productStateGray">처리완료</span></dd> -->
        </dl>
      </div>
    </div>
    <ul class="msg">
      <li>
        {{ $t('cancel.withdrawal_request_status') }}.
        <br />
        {{ $t('cancel.check_customer_service_response') }}
      </li>
      <li>
        {{ $t('cancel.refund_deposit_notice') }}
      </li>
    </ul>
  </div>
</template>

<script>
// getWithdrawDetail
import MyAPI from '@/api/my'
import ListItem from '@/views/my/ListItem'
import { convertCancelStatus } from '@/utils'

export default {
  name: 'CancelView',
  components: {
    ListItem
  },
  props: {
    purchaseId: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      data: {},
      paymentType: {
        1: '카카오페이',
        2: '토스페이',
        3: 'PAYCO',
        4: '문화상품권',
        5: '신용카드'
      }
    }
  },
  computed: {
    status() {
      return this.data.withdrawStatus
        ? convertCancelStatus(this.data.withdrawStatus)
        : ''
    }
  },
  mounted() {
    MyAPI.getWithdrawDetail(this.purchaseId, responseData => {
      this.data = responseData.data
    })
  }
}
</script>

<style lang="scss" scoped>
.history {
  .claimDate,
  .purchaseDate {
    padding: 0 16px;
    dt,
    dd {
      display: inline-block;
      font-size: 12px;
    }
    dt::after {
      content: '|';
      margin: 0 5px;
    }
  }
  .claimDate {
    padding-top: 7px;
    font-weight: bold;
  }
  .purchaseDate {
    padding-top: 9px;
    font-weight: normal;
  }
  .purchaseNum {
    font-size: 12px;
    padding-top: 9px;
    dt::after {
      margin: 0 5px;
    }
  }
  .payInfo {
    position: relative;
    dd {
      font-size: 13px;
    }
    dl:nth-child(1) {
      position: absolute;
      top: 17px;
      right: 16px;
      dd {
        font-size: 12px;
      }
    }
    dl:nth-child(2) {
      dd {
        font-weight: bold;
        font-size: 15px;
      }
    }
  }
}
</style>
